module.exports = __webpack_public_path__ + "img/c4d.4659ed3f.svg";